import realExam from "../../assets/images/services/realExam.webp";
import customBranded from "../../assets/images/services/customBranded.webp";
import lmsAndErp from "../../assets/images/services/lmsAndErp.webp";
import instantResults from "../../assets/images/services/instantResults.webp";

export const services = [
  {
    title: "Real Exam Simulation (CBT) With Exam Hall Protocol",
    subtitle: (
      <span>
        Deliver <strong>Mock Exams</strong> that feel exactly like the real
        thing.
      </span>
    ),
    description: [
      <span>
        {" "}
        <strong>Pan-India Center</strong> bookings for CBTs
      </span>,
      <span>Admit card generation</span>,
      <span>
        Student <strong>Document Verification</strong>{" "}
      </span>,
      <span>Frisking & live invigilation</span>,
      <span>
        Real exam UI ( <strong>SSC, IBPS, NEET formats</strong> )
      </span>,
      <span>Result generation & rank lists</span>,
    ],
    image: realExam,
  },
  {
    title: "Smart LMS & ERP Integration",
    subtitle: (
      <span>
        {" "}
        <strong>Manage Your Entire Institute</strong> from one intelligent
        dashboard
      </span>
    ),
    description: [
      <span>Batch, course & subject management</span>,
      <span>Fee tracking with automated reminders</span>,
      <span>Content sharing & study material uploads</span>,
      <span>Attendance tracking and test scheduling</span>,
      <span>Separate logins for admin, faculty & students</span>,
    ],
    image: lmsAndErp,
  },
  {
    title: "Instant Results & Advanced Analytics",
    subtitle: (
      <span>
        Say goodbye to <strong>Manual Checking</strong> and{" "}
        <strong>Slow Reporting</strong> .
      </span>
    ),
    description: [
      <span> <strong>Auto-evaluation</strong> (MCQs + Subjective)</span>,
      <span>Student-wise, subject-wise & topic-wise insights</span>,
      <span>Institute-wide performance dashboards</span>,
      <span>“<strong>Compare Yourself</strong>” benchmarking tools</span>,
      <span>Downloadable PDFs and <strong>Digital Report Cards</strong> </span>,
    ],
    image: instantResults,
  },
  {
    title: "Custom Branded Mobile Apps (iOS & Android)",
    id:'4',
    subtitle:  <span>Your coaching. <strong>Your Branding</strong> . Your app.</span>,
    description: [
        <span>Fully <strong>White-Labeled Mobile App</strong>  for your institute</span>,
        <span>Live test access, results & progress tracking</span>,
        <span>Push notifications, video content, and materials</span>,
        <span><strong>Android & IOS Compatible</strong></span>,
        <span><strong>Play Store</strong> & <strong>App Store</strong>  launch with your brand name & logo</span>
    ],
    image: customBranded,
  },
];
